// Copyright (c) 2026 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import { UseQueryResult } from '@tanstack/react-query';
import { CollateralState as CollateralStateV2 } from '@daml.js/utility-collateral-app-v2/lib/Utility/Collateral/App/Model/State/module';
import { useLedgerApiClient } from '../../../../contexts/LedgerApiContext';
import { useParties } from '../../../../contexts/PartiesContext';
import TemplateContract from '../../../../utils/TemplateContract';
import { useQueryWithOptions } from '../../../other/useQueryWithOptions';

export const useCollateralStateV2: () => UseQueryResult<
  TemplateContract<CollateralStateV2>[],
  string
> = () => {
  const ledgerApi = useLedgerApiClient();
  const { operator } = useParties();

  return useQueryWithOptions({
    queryKey: ['queryCollateralStateV2', operator],
    select: (data: TemplateContract<CollateralStateV2>[]) =>
      data.filter((d) => d.payload.operator === operator),
    queryFn: async (_, options) => {
      return ledgerApi.query(options, CollateralStateV2);
    },
  });
};
